import React from 'react'
import { FormLabel as ChakraFormLabel, FormLabelProps } from '@chakra-ui/react'
import { useTextColorFromShade } from 'components/core/utils/shade'

export const FormLabel = (props: FormLabelProps) => {
  const color = useTextColorFromShade(1)
  return <ChakraFormLabel fontSize="xs" fontFamily="label" fontWeight="bold" color={color} {...props} />
}
